const URL = "https://www.helpdesk.com/help";
const LIVECHAT_URL = "https://www.livechat.com/help";
const TEXT_URL = "https://help.text.com";

export const HelpCenter = {
  HOME: `${URL}/`,
  ENABLE_BROWSER_NOTIFICATIONS: `${URL}/enable-browser-notifications`,
  AUTOMATED_WORKFLOWS: `${URL}/automated-workflows`,
  SET_UP_CUSTOM_DOMAIN_AND_INBOX: `${URL}/set-up-custom-domain-and-inbox`,
  HELPDESK_REPORTS: `${URL}/helpdesk-reports`,
  WHAT_ARE_CANNED_RESPONSES: `${URL}/what-are-canned-responses`,
  CONTACT_FORM_FOR_YOUR_WEBSITE: `${URL}/contact-form-for-your-website`,
  CREATE_CUSTOM_FIELDS: `${URL}/create-custom-fields`,
  WHAT_ARE_MY_VIEWS: `${URL}/what-are-my-views`,
  EMAIL_TEMPLATE: `${URL}/email-template`,
  EMAIL_FORWARDING: `${URL}/forward-your-emails-to-helpdesk-and-convert-them-into-tickets/`,
  GMAIL_G_SUITE_EMAIL_FORWARDING: `${URL}/gmail-g-suite-email-forwarding`,
  MICROSOFT_OUTLOOK_EMAIL_FORWARDING: `${URL}/microsoft-outlook-email-forwarding`,
  MICROSOFT_OFFICE_365_EMAIL_FORWARDING: `${URL}/microsoft-office-365-email-forwarding`,
  LIVECHAT_INTEGRATION_IMPORT_DATA_FROM_LIVECHAT_TO_HELPDESK: `${URL}/livechat-integration-import-data-from-livechat-to-helpdesk`,
  SPAM_LIST: `${URL}/spam-list`,
  WHAT_ARE_TAGS_AND_HOW_TO_USE_THEM: `${URL}/what-are-tags-and-how-to-use-them`,
  WHAT_ARE_STATUSES: `${URL}/what-are-statuses`,
  ARCHIVE_TRASH_AND_SPAM_FOLDERS: `${URL}/archive-trash-and-spam-folders`,
  HOW_TO_MERGE_TICKETS: `${URL}/how-to-merge-tickets`,
  EMAIL_DELIVERY_TRACKING: `${URL}/email-delivery-tracking`,
  WHAT_IS_TICKET_RATING: `${URL}/what-is-ticket-rating`,
  INTEGRATE_HELPDESK_WITH_OPENWIDGET: `${URL}/integrate-helpdesk-with-openwidget`,
  CREATE_AND_APPLY_MACROS: `${URL}/how-to-create-and-apply-macros`,
  REPLY_ADDRESSES: `${URL}/set-up-custom-domain-and-inbox/#setting-up-the-reply-address`,
  DOMAINS: `${URL}/set-up-custom-domain-and-inbox/#setting-up-the-domain`,
  AUTO_ASSIGNMENTS: `${URL}/set-up-auto-assignments`,
  LANGUAGE_DETECTION: `${URL}/use-ticket-language-details`,
  REPLY_SUGGESTIONS: `${URL}/use-reply-suggestions`,
  ADD_HELPDESK_TO_THE_CHAT_WIDGET: `${URL}/add-helpdesk-to-the-chat-widget`,
  TAG_SUGGESTIONS: `${URL}/what-are-tags-and-how-to-use-them/#tag-suggestions`,
} as const;

export const LivechatHelpCenter = {
  ADD_HELPDESK_TO_THE_CHAT_WIDGET: `${LIVECHAT_URL}/add-helpdesk-to-the-chat-widget`,
} as const;

export const TextHelpCenter = {
  AUTOMATED_WORKFLOWS: `${TEXT_URL}/ticket-rules`,
  EMAIL_TEMPLATE: `${TEXT_URL}/email-templates`,
} as const;
